import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'COPModeloObraOF'

const GetCop = (workId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/itens/${workId}`, data, config)
const GetCopFile = (id, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/anexo/${id}`, data, config)
const PrintCop = (obraID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/relatorio?obraID=${obraID}`, data, config)
const PrintAllCop = (config = {}) => APIClient.get(`${APIPci}/${resourceName}/relatorio`, config)
const PostDatesCop = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const PostCopFile = (copModeloObraID, copModeloItemID, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/copModeloObraID/${copModeloObraID}/copModeloItemID/${copModeloItemID}/upload`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const DeleteCopFile = (copModeloObraID, copModeloItemID, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/copModeloObraID/${copModeloObraID}/copModeloItemID/${copModeloItemID}/upload`, data, config)

const COPOficialWorkModelRepository = {
  GetCop,
  GetCopFile,
  PrintCop,
  PrintAllCop,
  PostDatesCop,
  PostCopFile,
  DeleteCopFile
}

export default COPOficialWorkModelRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/copoficialworkmodel.js